import { Modal, message } from 'antd';
import axios, { AxiosRequestConfig, Canceler } from 'axios';
import OSS from 'ali-oss';
import { JSX } from 'react';
import { updateFileSubmitStatus } from './store/file';
import { IFileInfo } from './type';

const OSSConstants = {
  region: 'oss-cn-beijing',
  accessKeyId: 'LTAI5tPZPZDimnCPK77VCZxT',
  accessKeySecret: 'pyFFgRTpJUqIv1EbVknD5JAQ8PGpLc',
  bucket: 'charm123',
};
const client = new OSS({
  region: OSSConstants.region,
  accessKeyId: OSSConstants.accessKeyId,
  accessKeySecret: OSSConstants.accessKeySecret,
  bucket: OSSConstants.bucket,
});

export const alert = function (title: string | JSX.Element, button = '确定', cb = () => {}) {
  return Modal.info({
    title,
    content: '',
    okText: button,
    onOk: cb,
  });
};

export const confirm = function (title: string, text: JSX.Element, button = '确定', cb: Function, cancelFunc?: Function) {
  return Modal.confirm({
    title,
    content: text,
    okText: button,
    cancelText: '取消',
    onCancel: () => {
      if (cancelFunc) cancelFunc();
    },
    onOk: () => {
      cb();
    },
  });
};

export const formatUrl = function () {
  //@ts-ignore
  let str = this.toString();
  if (!arguments.length) {
    return str;
  }
  // eslint-disable-next-line prefer-rest-params
  let args = typeof arguments[0];
  // eslint-disable-next-line prefer-rest-params
  args = args === 'string' || args === 'number' ? arguments : arguments[0];
  //@ts-ignore
  for (const arg in args) {
    if (Object.prototype.hasOwnProperty.call(args, arg)) {
      const replace = args[arg] ? args[arg] : '';
      str = str.replace(RegExp('\\{' + arg + '\\}', 'gi'), replace);
    }
  }
  return str;
};

export const networkErr = function (err: Error) {
  console.error('networkErr err', err);
  if (err && err.message === 'Network Error') {
    message.error('请检查网络连接', 1);
  }
};

const axiosPendingArr: { u: string; cancel: Canceler }[] = [];
const removePending = (config: AxiosRequestConfig) => {
  for (const i in axiosPendingArr) {
    if (axiosPendingArr[i].u === config.url + '&' + config.method) {
      axiosPendingArr[i].cancel();
      axiosPendingArr.splice(Number(i), 1);
    }
  }
};

export const axiosInterceptorsConfig = () => {
  let currentDate = Date.now();
  let requestTimes = 0;
  let visitApiMoreTimes = false;
  let visitApiMoreTimesTimer: NodeJS.Timeout;
  const CancelToken = axios.CancelToken;
  axios.defaults.timeout = 10 * 60 * 1000;
  axios.interceptors.request.use(
    function (config) {
      requestTimes++;
      removePending(config);
      config.cancelToken = new CancelToken((c) => {
        axiosPendingArr.push({ u: config.url + '&' + config.method, cancel: c });
      });
      if (requestTimes > 50) {
        if (Date.now() - currentDate > 10 * 1000) {
          console.info('reset requestTimes');
          currentDate = Date.now();
          requestTimes = 0;
        } else {
          console.warn('more requests in short time config.url', config.url);
        }
      }
      return config;
    },
    function (err) {
      console.error('axios.interceptors.request err', err);
      return Promise.reject(err);
    },
  );

  axios.interceptors.response.use(
    (response) => {
      if (response.config) {
        if (response.config.method === 'get') {
          response.config.url = response.config.url!.split('userId=')[0].slice(0, -1);
        }
        removePending(response.config);
      }
      if (response && response.data) {
        return response.data.result;
      } else {
        console.error('axios.interceptors no response', response);
        // eslint-disable-next-line prefer-promise-reject-errors
        return Promise.reject('no response');
      }
    },
    (error) => {
      if (error && error.response) {
        if (!error.response.data) {
          console.error('axios.interceptors.response.use error.response', error.response);
        } else if (!error.response.data.result) {
          console.error('axios.interceptors.response.use error.response.data', error.response.data);
        } else if (error.response.data.result.errText === 'ip blocked') {
          if (!visitApiMoreTimes) {
            console.info('您在短时间内访问服务器次数过多，请稍后重试');
            visitApiMoreTimes = true;
          } else {
            clearTimeout(visitApiMoreTimesTimer);
          }
          visitApiMoreTimesTimer = setTimeout(() => {
            visitApiMoreTimes = false;
          }, 2000);
        }
        return Promise.reject(error && error.response && error.response.data); // 返回接口返回的错误信息
      } else {
        return Promise.reject(error);
      }
    },
  );
};

export const dealWithChildPage = (value: string) => {
  const pathname = location.pathname + '/' + value;
  return {
    pathname,
  };
};

export const isChildPageFunc = () => /^\/files\/.+/i.test(location.pathname);

export const checkFolderExist = (fileList: IFileInfo[], value: string) => {
  let flag = false;
  fileList.some((item) => {
    if (item.isFolder && item.filename === value) {
      flag = true;
      return true;
    } else {
      return false;
    }
  });
  return flag;
};

export const formatDate = (fmt: string, timestamp: number) => {
  let self = new Date();
  if (timestamp) {
    self = new Date(timestamp);
  }
  const o = {
    'M+': self.getMonth() + 1, //月份
    'd+': self.getDate(), //日
    'h+': self.getHours(), //小时
    'm+': self.getMinutes(), //分
    's+': self.getSeconds(), //秒
    'q+': Math.floor((self.getMonth() + 3) / 3), //季度
    S: self.getMilliseconds(), //毫秒
  };
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (self.getFullYear() + '').substr(4 - RegExp.$1.length));
  }
  for (const k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) {
      //@ts-ignore
      fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length));
    }
  }
  return fmt;
};

export const calcSize = (size: number) => {
  let formatSize = '';
  if (!size) return '未知';
  if (typeof size !== 'number') {
    return String(size);
  }
  if (size > 1073741824) {
    formatSize = (size / 1024 / 1024 / 1024).toFixed(2) + 'G';
  } else if (size > 1048576) {
    formatSize = (size / 1024 / 1024).toFixed(2) + 'M';
  } else if (size > 1024) {
    formatSize = (size / 1024).toFixed(0) + 'K';
  } else if (size < 1024) {
    formatSize = size + 'B';
  }
  return formatSize;
};

export const putObject = async (fileObject: File, folder: string, filename: string) => {
  try {
    console.info('putObject folder, filename', folder, filename);
    const result = await client.multipartUpload(`${folder}/${filename}`, fileObject, {
      progress(currentProgress) {
        $dispatch(updateFileSubmitStatus(`${(currentProgress * 100).toFixed(2)}% - ${filename}(${calcSize(fileObject.size)})`));
      },
      // meta: { name: fileObject.name, type: fileObject.type },
      mime: fileObject.type,
      headers: {
        'x-oss-request-id': Math.random().toString(36),
      },
    });
    console.info('putObject result', result);
    return result;
  } catch (e) {
    console.error('files putObject e', e);
    return Promise.reject(e);
  } finally {
    $dispatch(updateFileSubmitStatus('选择文件上传'));
  }
};

export const listOSSDir = async (dir: string) => {
  try {
    const result = await client.list(
      {
        prefix: dir,
        delimiter: '/',
        'max-keys': 1000,
      },
      {},
    );
    console.info('listOSSDir result', result);
    return result;
  } catch (e) {
    console.error('listOSSDir e', e);
    return Promise.reject(e);
  }
};

export const deleteOSSFile = async (objectKey: string) => {
  try {
    const result = await client.delete(objectKey);
    console.info('deleteOSSFile result', result);
    return result;
  } catch (e) {
    console.error('deleteOSSFile e', e);
    return Promise.reject(e);
  }
};
